import { render, staticRenderFns } from "./VxModal.vue?vue&type=template&id=d24bf768&scoped=true&"
import script from "./VxModal.vue?vue&type=script&lang=js&"
export * from "./VxModal.vue?vue&type=script&lang=js&"
import style0 from "./VxModal.vue?vue&type=style&index=0&id=d24bf768&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24bf768",
  null
  
)

export default component.exports